const {FinnishBusinessIds} = require("finnish-business-ids");

export default class Validator
{
	static validateEmail(email)
	{
		const re =
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}

	static validateSsn(ssn, allowShortSsn)
	{
		ssn = ssn.replace(/-/g, "");

		if (!allowShortSsn && ssn.length < 12)
		{
			return false;
		}

		if (allowShortSsn && ssn.length === 10)
		{
			ssn = "19" + ssn;
		}

		const numbers = ssn.match(
			/^(\d)(\d)(\d)(\d)(\d)(\d)(\d)(\d)(\d)(\d)(\d)(\d)$/
		);
		let checkSum = 0;

		if (
			numbers === null ||
			!isDate(ssn.substring(0, 4), ssn.substring(4, 6), ssn.substring(6, 8))
		)
		{
			return false;
		}

		let n;
		for (let i = 3; i <= 12; i++)
		{
			n = parseInt(numbers[i], 10);
			checkSum += i % 2 === 0 ? n : ((n * 2) % 9) + Math.floor(n / 9) * 9;
		}

		return checkSum % 10 === 0;

		// Helpers functions
		function isDate(year, month, day)
		{
			year = parseInt(year, 10);
			month = parseInt(month, 10) - 1; // 0-11
			day = parseInt(day, 10);

			const tmpDate = new Date(year, month, day);
			const validYear =
				year === (y => (y < 1000 ? y + 1900 : y))(tmpDate.getYear());
			const validMonth = month === tmpDate.getMonth();
			const validDay = day === tmpDate.getDate();

			return validYear && validMonth && validDay;
		}
	}

	static validateOrgNum(orgNum, allowShortSsn)
	{
		if (FinnishBusinessIds.isValidBusinessId(orgNum))
		{
			return true;
		}

		orgNum = orgNum.replace("-", "");

		if (!allowShortSsn && orgNum.length < 12)
		{
			return false;
		}

		if (orgNum.length === 12 && orgNum.substring(0, 2) === "16")
		{
			return orgNum[2] >= 2 && Validator.validateChecksum(orgNum.substring(2));
		}
		else if (orgNum.length === 10)
		{
			return orgNum[0] >= 2 && Validator.validateChecksum(orgNum);
		}

		return false;
	}

	static validateChecksum(number)
	{
		const array = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
		let length = number.length;
		let bit = 1;
		let sum = 0;
		let value;

		while (length)
		{
			value = parseInt(number.charAt(--length), 10);
			bit ^= 1;
			sum += bit ? array[value] : value;
		}

		return sum % 10 === 0;
	}

	static validateClearingNumber(number, bank, availableBanks)
	{
		if (isNaN(number) || number.length !== 4)
		{
			return false;
		}

		/**
		 * If there's a bank selected we check the accepted clearing number ranges
		 */
		if (bank && bank.length > 0)
		{
			let selectedBank = null;
			for (const bankName in availableBanks)
			{
				if (bankName === "length" || !availableBanks.hasOwnProperty(bankName))
				{
					continue;
				}
				if (bank === bankName)
				{
					selectedBank = availableBanks[bankName];
					break;
				}
			}

			if (selectedBank === null)
			{
				// Övrig bank - return true
				return true;
			}

			let clearingNoIsInRange = false;
			for (let i = 0; i < selectedBank.length; i++)
			{
				const clearingNoRange = selectedBank[i];
				if (
					number >= clearingNoRange["start"] &&
					number <= clearingNoRange["end"]
				)
				{
					clearingNoIsInRange = true;
					break;
				}
			}
			return clearingNoIsInRange;
		}

		// No bank selected, clearing number is invalid
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/classes/Validator.js